export default "__VITE_ASSET__59747227__"